<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2>
    {{ title }}
    <span style="font-size: 13px">{{ titleDetail }}</span>

    <mat-icon
      *ngIf="info"
      tabindex="0"
      [matTooltip]="info"
      matTooltipPosition="left"
      role="button"
      [attr.aria-label]="'Hinweis: ' + info"
      style="font-size: 20px; cursor: pointer; vertical-align: text-top">
      help_outline
    </mat-icon>
  </h2>
</div>
